import { germanMessages, deFootnotesNedc, co2 } from './common';

export default {
  ...germanMessages,
  'footnotes.wltp': `Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um die „WLTP ${co2}-Werte“ i.S.v. Art. 2 Nr. 1 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Der Stromverbrauch wurde auf der Grundlage der VO 692/2008/EG ermittelt. Die angegebenen Werte beziehen sich nicht auf ein bestimmtes Fahrzeug. Ihr einziger Zweck besteht darin, einen Vergleich zwischen verschiedenen Fahrzeugen zu ermöglichen. Die Werte können je nach Ausstattung und gewählten Optionen variieren.`,
  'footnotes.nedc': deFootnotesNedc,
  CONFIGURATOR: 'Configurateur',
};
